import { render, staticRenderFns } from "./IvPlacedAction.vue?vue&type=template&id=24baed1e&scoped=true&"
import script from "./IvPlacedAction.vue?vue&type=script&lang=js&"
export * from "./IvPlacedAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24baed1e",
  null
  
)

export default component.exports